







































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Branch, Company, Terminal } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { VendingResponse } from "@/domain/types";
import { getVendingConfig } from "@/domain/backend/vending";
import * as backend from "@/domain/backend";

@Component
export default class VendingConfigCopy extends Vue {
  @Prop() tcod!: string | null;
  @Prop() vendingDataID!: string | null;
  showCopyConfigDialog = false;
  submenuSearch = "";
  branchesToCopy: Branch[] | null = null;
  selectedCompanyToCopy: Company | null = null;
  selectedBranchToCopy: Branch | null = null;
  copyTerminalLoading = false;
  dataToCopy: VendingResponse | null = null;
  copyMessage: string | null = "";

  get userCompanies(): Company[] {
    return this.$store.state.userCompanies || [];
  }

  get submenuCompanies(): Company[] | null {
    const term = util.normalize(this.submenuSearch);
    return this.userCompanies.filter((c) => !term || util.normalize(c.name).includes(term));
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  show() {
    this.showCopyConfigDialog = true;
  }

  async selectCompanyToCopy(cpy: Company) {
    this.copyTerminalLoading = true;
    const company = await backend.getCompanyData(cpy.id);
    this.selectedCompanyToCopy = company;
    this.branchesToCopy = uiUtil
      .branchComboItems(company, this.$store.getters.userPermission)
      .filter((b) => b.isVending);
    this.submenuSearch = "";
    this.copyTerminalLoading = false;
  }

  async selectBranchToCopy(branch: Branch) {
    this.selectedBranchToCopy = branch;
    this.submenuSearch = "";
  }
  async selectTerminalToCopy(terminal: Terminal) {
    this.copyTerminalLoading = true;
    const res = await getVendingConfig(terminal.tcod);
    this.copyTerminalLoading = false;

    if (res.found) {
      this.dataToCopy = res;
      this.copyMessage = this.lang.ConfigFound;
    } else {
      this.copyMessage = this.lang.ConfigNotFound;
    }
    this.submenuSearch = "";
  }

  clearCopyConfig() {
    this.submenuSearch = "";
    this.copyMessage = null;
    this.branchesToCopy = null;
    this.selectedCompanyToCopy = null;
    this.selectedBranchToCopy = null;
    this.dataToCopy = null;
  }

  closeCopyConfigDialog() {
    this.clearCopyConfig();
    this.showCopyConfigDialog = false;
  }

  showElementToCopy(text: string) {
    if (!this.submenuSearch) return true;
    const content = (text || "").toLowerCase();
    if (content.includes(this.submenuSearch)) return true;
    return false;
  }

  executeCopyConfig() {
    if (this.dataToCopy?.found && this.dataToCopy.vendingConfig && !!this.tcod) {
      this.dataToCopy.vendingConfig.id = this.vendingDataID;
      this.dataToCopy.vendingConfig.TCOD = this.tcod;
      this.$emit("config-copied", { config: this.dataToCopy.vendingConfig });
    }
    this.closeCopyConfigDialog();
  }
}
